import BaseApi from './base'
import qs from 'qs'

class RecapAdditions extends BaseApi {
  constructor () {
    super()
  }
  async getList (params) {
    return this.auth({
      url: '/recap_additions',
      method: 'GET',
      params: { ...params },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false, encode: false })
      }
    })
  }
  async get (id) {
    return this.auth({
      url: `/recap_addition/${id}`,
      method: 'GET'
    })
  }
  async post (payload) {
    return this.auth({
      url: '/recap_addition',
      method: 'POST',
      data: payload
    })
  }
  async put (payload) {
    return this.auth({
      url: `/recap_addition`,
      method: 'PUT',
      data: payload
    })
  }
  async delete (id) {
    return this.auth({
      url: `/recap_addition/${id}`,
      method: 'DELETE'
    })
  }
  async downloadTemplate () {
    return this.auth({
      url: `/recap_addition/download/template`,
      method: 'GET'
    })
  }
}

export default new RecapAdditions()